import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../rootReducer'

export type PartialDebitData = {
  iban?: string
  bic?: string
  payer_name?: string
  payer_street?: string
  payer_zip?: string
  payer_city?: string
  payer_is_holder?: boolean
  holder_name?: string
  holder_street?: string
  holder_zip?: string
  holder_city?: string
  acknowledged?: boolean
  payer_address?: string
  holder_address?: string
}

export interface IDiscountCode {
  code: string
  discount: number
  program: number
  events: number[]
  used_code: string
}

export const initialState = {
  method: '',
  discountCodes: [] as IDiscountCode[],
  debitData: {
    iban: '',
    bic: '',
    payer_name: '',
    payer_street: '',
    payer_zip: '',
    payer_city: '',
    payer_is_holder: false,
    holder_name: '',
    holder_street: '',
    holder_zip: '',
    holder_city: '',
    acknowledged: false,
  } as PartialDebitData,
}

const paymentData = createSlice({
  name: 'paymentData',
  initialState,
  reducers: {
    setPaymentMethod(state, action: PayloadAction<string>) {
      state.method = action.payload
    },
    updateDebitData(state, action: PayloadAction<PartialDebitData>) {
      state.debitData = { ...state.debitData, ...action.payload }
    },
    updateDiscountCodes(state, action: PayloadAction<{ discountCode: IDiscountCode, action: 'add' | 'remove' }>) {
      const codeIncluded = state.discountCodes.find((d) => d.code.trim() === action.payload.discountCode.code.trim());
      if (action.payload.action === 'add' && !codeIncluded) {
        state.discountCodes.push(action.payload.discountCode)
      } else if(action.payload.action === 'remove') {
        state.discountCodes = state.discountCodes.filter(d => d.code.trim() !== action.payload.discountCode.code.trim());
      }
    }
  },
})

export const { setPaymentMethod, updateDebitData, updateDiscountCodes } = paymentData.actions
export default paymentData.reducer

export const applyDiscountCode = (
  discount_code: string,
  action: 'add' | 'remove'
): AppThunk<Promise<Boolean>> => async (dispatch, getState) => {
  console.log(`${action}ing DiscountCode ${discount_code}`)
  try {
    const { baseUrl, programId } = getState().misc
    const response = await fetch(
      `${baseUrl}/api/custom/validate/discountcode/${programId}/${discount_code}/`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    const discountCode: IDiscountCode = await response.json()
    if (response.status === 200) {
      // we want to set this back to the userinputted value here, especially for handling schema codes
      discountCode.used_code = discount_code
      dispatch(updateDiscountCodes({ discountCode, action }))
      return true
    }else {
      return false
    }
  } catch (error: unknown) {
    console.log(error)
    return false
  }
}
